var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvalidIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.58624 21.4142C6.97624 21.8052 7.48824 22.0002 8.00024 22.0002C8.51224 22.0002 9.02424 21.8052 9.41424 21.4142L14.0002 16.8282L18.5862 21.4142C18.9762 21.8052 19.4882 22.0002 20.0002 22.0002C20.5122 22.0002 21.0242 21.8052 21.4142 21.4142C22.1952 20.6332 22.1952 19.3672 21.4142 18.5862L16.8282 14.0002L21.4142 9.41424C22.1952 8.63324 22.1952 7.36724 21.4142 6.58624C20.6342 5.80524 19.3662 5.80524 18.5862 6.58624L14.0002 11.1722L9.41424 6.58624C8.63424 5.80524 7.36624 5.80524 6.58624 6.58624C5.80524 7.36724 5.80524 8.63324 6.58624 9.41424L11.1722 14.0002L6.58624 18.5862C5.80524 19.3672 5.80524 20.6332 6.58624 21.4142Z",
    fill: "#C0392B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvalidIcon);
export default __webpack_public_path__ + "static/media/InvalidIcon.e2295285f88f1919e4fa40398739e2b4.svg";
export { ForwardRef as ReactComponent };